import { Injectable, WritableSignal } from '@angular/core';

import { NavigationService } from '@core/services/navigation/navigation.service';

import { BaseProfileCommand } from '@shared/commands/base-profile.command';
import { IProfileCommandContext } from '@shared/models/profile-command.model';

/**
 * Команда для управления уведомлениями из профиля пользователя
 *
 * Открывает страницу управления PUSH и SMS-уведомлениями. Команда является точкой входа
 * для управления уведомлениями для всех карт пользователя.
 *
 * Особенности:
 * - Переводит на страницу `/other/profile/notifications`
 * - Не имеет чекбокса (только навигация)
 * - Находится в группе 'main' для основных команд профиля
 * - Использует иконку 'notification' (звонок)
 *
 * @example
 * ```typescript
 * const context = { data: {} };
 * await notificationsCommand.execute(context); // Переход на страницу уведомлений
 * ```
 */
@Injectable()
export class NotificationsSettingsCommand extends BaseProfileCommand {
  readonly type = 'notificationsSettings';
  readonly title = 'Уведомления';
  readonly subtitle?: WritableSignal<string> = undefined;
  readonly icon = 'notification';
  readonly checkbox?: 'unchecked' | 'checked' | 'disabled' | null = null;
  readonly hidden = false;
  readonly group = 'main';
  readonly order = 2;
  readonly settingsNames?: string[] = undefined;

  constructor(private readonly navigationService: NavigationService) {
    super();
  }

  /**
   * Выполнить команду - открыть страницу управления уведомлениями
   *
   * @param _context - контекст выполнения команды (не используется)
   */
  async execute(_context: IProfileCommandContext): Promise<void> {
    await this.navigationService.push('/other/profile/notifications');
  }
}
